<template>
  <div>
    <vxe-grid
      ref="skuTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      row-id="evgSkuCode"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :radio-config="
        !multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              strict: false,
              reserve: reserve,
            }
          : {}
      "
      :checkbox-config="
        multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              reserve: reserve,
            }
          : {}
      "
      @radio-change="radioChange"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:displayColor="{ row }">
        <span>{{ row.goodsColor }}</span>
        <br />
        <span>{{ row.goodsColorEn }}</span>
      </template>
      <template v-slot:displayHscodeName="{ row }">
        <span>{{ row.hscodeName }}</span>
        <br />
        <span>{{ row.hscodeNameEn }}</span>
      </template>
      <template v-slot:needInspection="{ row }">
        <el-tag
          v-if="row.v_needInspection"
          size="mini"
          :type="row.needInspection === 'Y' ? 'success' : 'warning'"
        >
          {{ row.v_needInspection }}
        </el-tag>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.evgSkuStatus === 'Y'
              ? 'success'
              : row.evgSkuStatus === 'D'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_evgSkuStatus }}
        </el-tag>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:ftyPrice="{ row }">
        {{ row.ftyPrice || '' }}
        {{ row.v_ftyPriceCurrencyUnit || '' }}
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    tableHeight: { type: Number, default: 800 },
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: false },
    highlight: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('choose-change', records.concat(reserves))
    },
    radioChange({ newValue }) {
      this.$emit('choose-change', newValue)
    },
  },
}
</script>
